import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Grid } from '@mui/material';
import { useHistory, Link } from 'react-router-dom';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import SimpleCardTemplate from '#component/general/simple-card-template';
import ArrowRightButton from '#component/general/arrow-right-button';
import ApplianceModal from '#component/warehouse/cards-view/appliance-modal/appliance-modal';
import PreloaderComponent from '#component/preloader';
import HighlightWord from '#component/general/highlight-word/highlight-word';
import { getHighlightedSearchResult } from '#component/general/highlight-word/helper';
import { StyledPagination, ApplianceLinkButton } from './styles';

const SitesTabContent = ({
  paginatedWarehousesWithAppliances,
  handleSitesDrawerMenuOpen,
  setSelectedSite,
  page,
  pages,
  handlePageChange,
  isLoading
}) => {
  const history = useHistory();
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [isApplianceModalOpen, setIsApplianceModalOpen] = useState(false);
  const listFilter = useSelector(s => s.listFilter, shallowEqual);
  const highlightedSearchResult = getHighlightedSearchResult(listFilter);

  const handleOpenModal = warehouse => {
    setSelectedWarehouse(warehouse);
    setIsApplianceModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsApplianceModalOpen(false);
    setSelectedWarehouse(null);
  };

  if (isLoading) {
    return <PreloaderComponent />;
  }

  return (
    <Grid container columnSpacing={1} mt={1} mb={8}>
      {paginatedWarehousesWithAppliances && paginatedWarehousesWithAppliances.map(fullWarehouse =>
        <Grid item xs={12} sm={6} md={6} key={fullWarehouse.id}>
          <SimpleCardTemplate
            onCardClickHeader={() => history.push(`/warehouse/edit/${fullWarehouse.id}`)}
            title={
              highlightedSearchResult ? <HighlightWord
                textToHighlight={fullWarehouse.label}
                searchWord={highlightedSearchResult}
              /> : fullWarehouse.label
            }
            icon={<WarehouseIcon color="secondary" />}
            onClickMore={() => {
              handleSitesDrawerMenuOpen();
              setSelectedSite(fullWarehouse);
            }}
            cardContents={[
              { title: 'Project', content: fullWarehouse?.project?.title },
              fullWarehouse.appliances && fullWarehouse.appliances.length > 0 ? {
                title: 'Appliances',
                content: fullWarehouse.appliances.length === 1 ? (
                  <ApplianceLinkButton
                    color="secondary"
                    aria-label="Application"
                    component={Link}
                    to={`/warehouse/appliance/edit/${fullWarehouse.appliances[0].id}`}
                  >
                    {fullWarehouse.appliances[0].label}
                  </ApplianceLinkButton>
                ) : (
                  <ArrowRightButton onClickArrowRight={() => handleOpenModal(fullWarehouse)} />
                )
              } : {}
            ]}
          />
        </Grid>)}
      {paginatedWarehousesWithAppliances.length > 0 && (!!pages && Number(pages) > 1) && (
        <Grid container justifyContent="center">
          <Grid item>
            <StyledPagination
              shape="rounded"
              color="secondary"
              count={pages}
              page={page}
              onChange={handlePageChange}
            />
          </Grid>
        </Grid>
      )}

      <ApplianceModal
        isOpen={isApplianceModalOpen}
        onClose={handleCloseModal}
        selectedWarehouse={selectedWarehouse}
      />
    </Grid>
  );
};

export default SitesTabContent;
